import { Button, Flex, Form, Input, Radio } from "antd";
import type { ModalType } from "../../../../hooks/useModal";
import CustomModal from "../../../../components/CustomModal";
import useError from "../../../../hooks/useError";
import {
  useCreateOptionMutation,
  useUpdateOptionMutation,
} from "../../../../app/features/adminContent/adminContent.api";
import { useEffect } from "react";
import { toast } from "../../../../lib/toast";

interface Props {
  open: boolean;
  onCancel: () => void;
  initialValues?: any | null;
  type?: ModalType["type"];
}

export default function ManageOptionsModal({
  open,
  onCancel,
  initialValues,
  type,
}: Props) {
  const [form] = Form.useForm();
  // Mutation API
  const [
    createOption,
    { isLoading: createLoading, isSuccess: createSuccess, error: createError },
  ] = useCreateOptionMutation();
  const [
    updateOption,
    { isLoading: updateLoading, isSuccess: updateSuccess, error: updateError },
  ] = useUpdateOptionMutation();
  // Error Handeling
  useError(createError, "Question Option Create Failed");
  useError(updateError, "Question Option Update Failed");

  const handleSubmit = async (values: any) => {
    const newData = {
      ...values,
      questionId: Number(initialValues?.id),
      key: "TRUE",
    };

    const updateData = {
      ...values,
      key: "TRUE",
    };

    if (initialValues && type === "UPDATE_OPTIONS") {
      // 🔥 call mutation with both id and body
      await updateOption({
        id: initialValues?.id, // <--- pass the quiz id here
        body: updateData, // <--- pass the updated data
      });
    } else {
      await createOption(newData);
    }
  };

  console.log("initialValues:", initialValues);

  useEffect(() => {
    if (initialValues && type === "UPDATE_OPTIONS") {
      form.setFieldsValue({
        text: initialValues?.text,
        isCorrect: initialValues?.isCorrect,
      });
    }
  }, [initialValues, form, open, type]);

  useEffect(() => {
    if (createSuccess) {
      toast("success", "Question Option Created Successfully");
      onCancel();
    }
  }, [createSuccess]);

  useEffect(() => {
    if (updateSuccess) {
      toast("success", "Question Option Updated Successfully");
      onCancel();
    }
  }, [updateSuccess]);

  return (
    <CustomModal
      handleClose={onCancel}
      title={type === "UPDATE_OPTIONS" ? "Update Option" : "Create Option"}
      open={open}
      width={500}
      footer
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ isActive: true, sortOrder: 0 }}
        className="custom-form"
        size="large"
      >
        <Form.Item
          label="Option Title"
          name="text"
          rules={[{ required: true, message: "Please enter option title" }]}
        >
          <Input placeholder="Enter Option Title" />
        </Form.Item>

        <Form.Item
          label="Option Answer"
          name="isCorrect"
          initialValue={false} // default false
          rules={[{ required: true, message: "Please select option answer" }]}
        >
          <Radio.Group style={{ display: "flex", gap: 20 }}>
            <Radio value={true}>Correct</Radio>
            <Radio value={false}>Incorrect</Radio>
          </Radio.Group>
        </Form.Item>

        <Flex justify="end" gap={8} className="mt-12">
          <Button
            className="min-w-[120px]"
            disabled={createLoading || updateLoading}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="min-w-[120px]"
            htmlType="submit"
            loading={createLoading || updateLoading}
          >
            {type === "UPDATE_OPTIONS" ? "Update" : "Create"}
          </Button>
        </Flex>
      </Form>
    </CustomModal>
  );
}
